// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { DeviceMediaRequest, IDeviceMediaRequest } from "./DeviceMediaRequest.gen";

export interface IMediaRequestResult {
	data: IDeviceMediaRequest[] | undefined;

	hasMore: boolean;

	nextCursor: string | undefined;

	count: number;

	$type?: string | undefined;
}
export class MediaRequestResult {
	constructor(data?: IMediaRequestResult) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.data = data.data ? data.data.map((d: any) => new DeviceMediaRequest(d)) : [];
	}

	data: DeviceMediaRequest[] | undefined = [];

	hasMore: boolean = false;

	nextCursor: string | undefined;

	count: number = 0;

	static $type: string = "CoreApi.Models.Pagination.MediaRequestResult, ";
	$type?: string | undefined = MediaRequestResult.$type;
}

